import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DocumentDetailDto } from '../../../shared/models/document-details-dto';
import { PanelList } from '../../../shared/models/panel-list';
import { DocumentLibraryConstants } from '../../document-library-constants';
import { DocumentVersionReview } from '../../models/documentVersionReview';
import { DocumentService } from '../../services/document.service';
import { PhaseValueConstants } from '../../../shared/constants/phaseValues-constants';
import { catchError, throwError } from 'rxjs';
import { CommonService } from '../../../shared/services/common.service';
import { AuthenticationHelperService } from '../../../shared/components/authentication-maintainance/services/authentication-helper.service';



@Component({
  selector: 'app-review-status',
  templateUrl: './review-status.component.html',
  styleUrls: ['./review-status.component.scss']
})
export class ReviewStatusComponent implements OnInit {
  @Output() isReviewStatusModalVisible=new EventEmitter<boolean>();
  @Output() setDocumentDetailsLoader = new EventEmitter<any>();
  display: boolean = true;
  @Input() documentNumber!: string;
  @Input() documentVersion!: string;
  @Input() showCompleteButton!:boolean;
  @Input() showCompleteButtonWhenFileCheckedOut!:boolean;
  isTriggeredFromReview:boolean=false;
  isReviewStatusDataAvailable:boolean = true;  
  documentPhase!:string;
  isChangeRequestHistoryModalShow:boolean=true;
  latestDocumentVersion = 0;
  isLatestVersion = false;
  displayCRIHistoryModal:boolean=false;
  CRIItemsExits:boolean=false;
  isFinalDocumentReviewer:boolean=false;
  @Input() documentDetailsDto!: DocumentDetailDto;
  documentVersionReviewForProceed!: DocumentVersionReview;
  confirmationMessage:string=DocumentLibraryConstants.Doc_Version_Review_Confirmation_Message;
  docVersionReviewData:any;
  showEsignatureConfirmationDialog:any=false;
  reviewStatusData: PanelList={
    lists:[],
    filters:[],
    sort:[]
  };
  lists:any=[]
  documentVersionReview !:DocumentVersionReview;
  documentVersionsHistoryModalInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: false,
    enableSort: false,
    enableSelection: false,
  };
  showLoader : boolean = false;

  constructor(private router: Router, private documentService: DocumentService, private messageService : MessageService,
    private commonService : CommonService, private readonly authenticationHelperService: AuthenticationHelperService) { }

  ngOnInit(): void {
    this.initialize();
    this.getdocumentVersions();
  }
  getdocumentVersions = () => {
    this.documentService
      .getDocumentVersions(this.documentDetailsDto.number)
      .subscribe((documentVersions) => {
        this.documentVersionsHistoryModalInput.lists = documentVersions;
        this.latestDocumentVersion =
          documentVersions && documentVersions.length > 0
            ? documentVersions[0]?.version
            : 0;
      });
  };
  
  initialize(){
    this.showLoader = true;
  this.documentService.getReviewStatus(this.documentNumber,this.documentVersion).subscribe(
    serviceData=>{
      this.reviewStatusData.lists = serviceData;
      this.isReviewStatusDataAvailable = !this.commonService.IsListEmpty(serviceData);
      this.showLoader = false;
      let pendingCRICount = this.reviewStatusData.lists.filter( (x: { status: number; }) => x.status==0 );
      pendingCRICount.length==1? this.isFinalDocumentReviewer=true:false;

      this.addFilters();
      this.addSorting();
    } );
    
  }

  addFilters():void{
    this.reviewStatusData.enableFilter=true;
    this.reviewStatusData.filters?.push({
      filterDisplayName:"Status",
      filterFieldName:"statusName"
    });
    this.reviewStatusData.filters?.push({
      filterDisplayName:"Reviewer",
      filterFieldName:"reviewer"
    } );
  }

  addSorting():void{
  this.reviewStatusData.enableSort=true;
  this.reviewStatusData.sort?.push(
    {
      sortFieldDisplayName:"Status",
      sortFieldName:"statusName"
    }
  );
  this.reviewStatusData.sort?.push(
    {
      sortFieldDisplayName:"Reviewer",
      sortFieldName:"reviewer"
    }
  );

  }
  reloadDocumentDetail() {
    this.isReviewStatusModalVisible.emit(false);
  }

  generateDocumentDetailsDto = (version: string, phase: number) => {
    this.documentDetailsDto.number=this.documentNumber;
    this.documentDetailsDto.version = version;
    this.documentDetailsDto.phase = phase;
  };
  closeChangeRequestItemHistoryModal = (isShow: boolean) => {
    this.isChangeRequestHistoryModalShow = isShow;
  };

  updateIsLatestVersion(isLatest: boolean): void {
    this.isLatestVersion = isLatest;
    this.getdocumentVersions();
  }

completeDocumentReviewAndUpdateStatus(documentVersionReview : DocumentVersionReview){
  this.showEsignatureConfirmationDialog=true;
  this.docVersionReviewData=documentVersionReview;
  
}

updateReviewStatusAfterProceed(event:boolean)
{
  this.completeDocumentReviewAndUpdateStatus(this.documentVersionReviewForProceed)
}

  updateReviewStatus(documentVersionReview : DocumentVersionReview){
    this.documentService.getPendingAndNextPeriodicChangeRequestItemsForDocument
    (documentVersionReview.documentNumber,documentVersionReview.documentVersion,PhaseValueConstants.InReview)
    .pipe(
      catchError((err) => {
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Err,
          summary: `${err.error}`,
        });
        return throwError(() => err);
      })
    )
    .subscribe(
      serviceData => {
        this.CRIItemsExits=serviceData;
    if( this.isFinalDocumentReviewer && this.CRIItemsExits)
    {
      this.documentVersionReviewForProceed=documentVersionReview;
      this.isTriggeredFromReview=true;
      this.isChangeRequestHistoryModalShow = true; 
      this.displayCRIHistoryModal=true;
    }
    else{
      this.completeDocumentReviewAndUpdateStatus(documentVersionReview);
    }
   });
  }

  onConfirm(){
    this.authenticationHelperService.reauth(this.saveSignature.bind(this), this.closeConfirmationModal.bind(this));
  }

  saveSignature(){
    this.showEsignatureConfirmationDialog=false;
    //Call to FAMS Auth and validation
    //On validation success proceed with capturing in audit
    this.documentService.updateReviewStatus(this.docVersionReviewData)
  .pipe(
    catchError((err) => {
      this.setDocumentDetailsLoader.emit(false);
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Err,
        summary: `${err.error}`,
      });
      return throwError(() => err);
    })
  )
  .subscribe({
    next: () => {
        this.display = false;
        this.reloadDocumentDetail();
    },
    error: () => {
        this.setDocumentDetailsLoader.emit(false);
    }
  });
  }
closeConfirmationModal(){
this.showEsignatureConfirmationDialog=false;
}
}
